import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";

const customRoutes = [
  { method: "GET", path: "/recent", handlerName: "getRecent" },
  { method: "GET", path: "/by-priority/:priority", handlerName: "getByPriority" },
  { method: "GET", path: "/by-status/:status", handlerName: "getByStatus" },
  { method: "GET", path: "/statistics", handlerName: "getStatistics" },
  { method: "GET", path: "/client-admin/:id", handlerName: "getClientAdmin" },
  { method: "POST", path: "/:id/update-status", handlerName: "updateStatus" },
];

export const incidentsService = createCrudService("incidents", customRoutes, router);